// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textiAI{
  color: lightblue;
}

.mesazhi-per-foto{
  color: rgb(51, 158, 230);
}

/* Pages Manager Styles - Clean Professional Design */
.pages-manager {
  display: flex;
  gap: 0;
  min-height: 600px;
  max-height: 85vh;
  background: #f8f9fa;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
}

/* Wraps page-limit-info + page-bg-colors + PhotoLibrary into ONE flex-row
   column (previously these were 3 unwrapped siblings each competing
   independently for width in .pages-manager's flex row, which is what let
   them collectively starve .pages-main - the canvas - down to as little as
   30px wide on common laptop screens; see PagesManager.js). flex-shrink:0
   plus no explicit width lets it size to its widest child (.photo-library's
   own fixed width below), and the column's default \`align-items: stretch\`
   makes page-limit-info/page-bg-colors automatically match that width
   instead of each claiming their own row slot. */
.pages-secondary-panel {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 12px;
  padding: 12px 0 12px 12px;
}

/* Photo Library Sidebar */
.photo-library {
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  padding: 15px 12px;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 85vh;
  overflow: hidden;
}

.library-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e2e8f0;
}

.library-header h4 {
  color: #2d3748;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.photo-count-badge {
  background: #667eea;
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  min-width: 20px;
  text-align: center;
}

.add-photos-btn {
  padding: 10px 15px;
  background: #2d3748;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.add-photos-btn:hover {
  background: #1a202c;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.add-photos-phone-btn {
  padding: 10px 15px;
  background: transparent;
  color: #2d3748;
  border: 1.5px solid #cbd5e0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.add-photos-phone-btn:hover:not(:disabled) {
  border-color: #2d3748;
  background: #f7fafc;
}

/* ── Mobile pairing (QR / link) modal ── */
.mobile-pairing-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  background: rgba(20, 20, 24, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.mobile-pairing-card {
  position: relative;
  width: 100%;
  max-width: 340px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  padding: 28px 24px 24px;
  text-align: center;
}

.mobile-pairing-close {
  position: absolute;
  top: 10px;
  right: 12px;
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  color: #718096;
  cursor: pointer;
}

.mobile-pairing-card h3 {
  margin: 0 0 6px;
  font-size: 17px;
  color: #1a202c;
}

.mobile-pairing-subtitle {
  margin: 0 0 18px;
  font-size: 13px;
  color: #718096;
}

.mobile-pairing-qr {
  display: flex;
  justify-content: center;
  padding: 12px;
  background: #f7fafc;
  border-radius: 12px;
  margin-bottom: 16px;
}

.mobile-pairing-link-row {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}

.mobile-pairing-link-row input {
  flex: 1 1;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 11px;
  color: #4a5568;
  background: #f7fafc;
}

.mobile-pairing-link-row button {
  padding: 8px 14px;
  background: #2d3748;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
}

.mobile-pairing-status {
  margin: 0;
  font-size: 13px;
  color: #4a5568;
  font-weight: 500;
}

.library-photos {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 8px;
  min-height: 0;
  /* Performance optimizations for smooth scrolling */
  transform: translateZ(0);
  -webkit-overflow-scrolling: touch;
}

/* Custom scrollbar for photo library */
.library-photos::-webkit-scrollbar {
  width: 6px;
}

.library-photos::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.library-photos::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.library-photos::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

.library-photo {
  position: relative;
  aspect-ratio: 1;
  /* border-radius: 6px;
  overflow: hidden; */

  /* Performance optimizations */
  /* contain: layout style paint;
  will-change: transform;
  transition: all 0.2s ease; */
}

.library-photo-delete {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 14px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
}

.library-photo-delete:hover {
  background: #e53e3e;
}

/* .library-photo:hover {
  border-color: #667eea;
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
} */


.library-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Performance optimizations */
  /* content-visibility: auto;
  contain-intrinsic-size: 80px 80px; */
}

.empty-library {
  grid-column: span 2;
  text-align: center;
  padding: 30px 10px;
  color: #a0aec0;
}

.empty-library span {
  font-size: 36px;
  display: block;
  margin-bottom: 10px;
  opacity: 0.5;
}

.empty-library p {
  font-size: 12px;
  margin: 0;
  color: #718096;
}

.pages-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
  padding: 15px;
  gap: 12px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 85vh;
}

/* Toolbar */
.pages-toolbar {
  display: flex;
  gap: 10px;
  padding: 12px 15px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  border: 1px solid #e2e8f0;
}

.toolbar-action {
  padding: 10px 16px;
  background: #ffffff;
  color: #2d3748;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.toolbar-action:hover {
  background: #f7fafc;
  border-color: #2d3748;
}

.toolbar-action.danger {
  color: #e53e3e;
  border-color: #feb2b2;
}

.toolbar-action.danger:hover {
  background: #fff5f5;
  border-color: #e53e3e;
}

.toolbar-action.disabled,
.toolbar-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

/* Page limit info. flex-shrink + min-width:0 + flex-wrap let this actually
   shrink/wrap its text instead of forcing its full single-line content
   width, which is what was starving .pages-main of space (see comment
   there) at common laptop widths - it's a flex ROW child of
   .pages-manager just like .photo-library/.pages-main. */
.page-limit-info {
  display: flex;
  align-items: center;
  flex-shrink: 1;
  min-width: 0;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 15px;
  background: #edf2f7;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.page-limit-info .info-icon {
  font-size: 14px;
}

.page-limit-info span {
  color: #4a5568;
  font-size: 13px;
}

/* Layout picker */
.layout-picker-overlay {
  display: none;
}

.layout-picker {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border: 1px solid #e2e8f0;
}

.layout-picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.layout-picker h4 {
  color: #2d3748;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.layout-picker-close {
  display: none;
  width: 32px;
  height: 32px;
  border: none;
  background: #f0f0f0;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  color: #666;
  transition: all 0.2s;
}

.layout-picker-close:hover {
  background: #e0e0e0;
  color: #333;
}

.layouts-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.layout-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px 8px;
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.layout-option:hover {
  background: #edf2f7;
  border-color: #2d3748;
}

.layout-option.active {
  background: #2d3748;
  border-color: #2d3748;
}

.layout-option.active .layout-icon,
.layout-option.active .layout-name {
  color: white;
}

.layout-icon {
  font-size: 18px;
  color: #2d3748;
  white-space: pre-line;
  line-height: 1.2;
}

.layout-name {
  font-size: 10px;
  color: #718096;
  text-align: center;
}

/* Page background colors */
.page-bg-colors {
  display: flex;
  align-items: center;
  flex-shrink: 1;
  min-width: 0;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 15px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.page-bg-colors span {
  color: #718096;
  font-size: 12px;
  font-weight: 500;
}

.page-color-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.page-color-btn:hover {
  transform: scale(1.1);
  border-color: #a0aec0;
}

.page-color-btn.active {
  border-color: #2d3748;
  box-shadow: 0 0 0 2px rgba(45, 55, 72, 0.2);
}

/* Current page container */
.current-page-container {
  flex: 1 1;
  width: 100%;
  max-width: 700px;
  align-self: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  min-height: 400px;
  max-height: 55vh;
  overflow: hidden;
  gap: 16px;
}

/* Vertical text panel */
.text-panel-vertical {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #1a202c;
  border-radius: 10px;
  padding: 10px 6px;
  width: 68px;
  min-width: 68px;
  max-width: 68px;
  align-self: stretch;
  box-shadow: 0 4px 16px rgba(0,0,0,0.25);
  flex-shrink: 0;
}

.text-panel-label {
  display: block;
  color: #a0aec0;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-panel-section {
  display: flex;
  flex-direction: column;
}

.text-panel-row {
  display: flex;
  gap: 2px;
}

.text-panel-select {
  background: #2d3748;
  color: #fff;
  border: 1px solid #4a5568;
  border-radius: 5px;
  padding: 3px 2px;
  font-size: 10px;
  width: 100%;
  cursor: pointer;
}

.text-panel-select:focus { outline: none; border-color: #667eea; }

.text-panel-size {
  background: #2d3748;
  color: #fff;
  border: 1px solid #4a5568;
  border-radius: 5px;
  padding: 3px 2px;
  font-size: 11px;
  width: 100%;
  text-align: center;
}

.text-panel-size:focus { outline: none; border-color: #667eea; }

.text-panel-btn {
  flex: 1 1;
  background: #2d3748;
  color: #e2e8f0;
  border: 1px solid #4a5568;
  border-radius: 5px;
  padding: 4px 2px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
  min-width: 0;
}

.text-panel-btn:hover { background: #4a5568; }
.text-panel-btn.active { background: #667eea; border-color: #667eea; color: #fff; }

.text-panel-color {
  width: 100%;
  height: 28px;
  border: 1px solid #4a5568;
  border-radius: 5px;
  cursor: pointer;
  padding: 0;
  background: none;
}

.text-panel-btn-apply {
  background: #38a169;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 5px 2px;
  font-size: 9px;
  cursor: pointer;
  width: 100%;
  transition: background 0.15s;
  line-height: 1.3;
  word-break: break-word;
}

.text-panel-btn-apply:hover { background: #2f855a; }

.text-panel-btn-delete {
  background: transparent;
  color: #fc8181;
  border: 1px solid #fc8181;
  border-radius: 5px;
  padding: 5px 4px;
  font-size: 11px;
  cursor: pointer;
  width: 100%;
  transition: all 0.15s;
}

.text-panel-btn-delete:hover { background: #c53030; border-color: #c53030; color: #fff; }

/* Page editor */
.page-editor {
  width: 100%;
  max-width: 320px;
  aspect-ratio: 210 / 297; /* A4 ratio */
  position: relative;
  border-radius: 4px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: #fff;
}

.page-editor.selected {
  outline-offset: 5px;
}

/* Open-book spread (desktop/tablet only — PagesManager renders a single
   .page-editor instead on mobile). The two pages butt together (no gap)
   and share ONE outer shadow/rounding, like a single open book, instead of
   each page looking like its own separate card; a gradient "gutter" shadow
   is overlaid at the seam (::after below) to read as the book's fold. */
.page-spread {
  display: flex;
  gap: 0;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  max-width: 640px;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.18);
}

.page-spread .page-editor,
.page-spread-blank {
  flex: 1 1;
  width: auto;
  max-width: none;
  aspect-ratio: 210 / 297;
  border-radius: 0;
  box-shadow: none;
}

.page-spread .page-editor:first-child,
.page-spread-blank:first-child {
  border-radius: 4px 0 0 4px;
}

.page-spread .page-editor:last-child,
.page-spread-blank:last-child {
  border-radius: 0 4px 4px 0;
}

.page-spread-blank {
  background: #fdfdfb;
}

/* Gutter shadow — the soft dark seam a real open book casts down its
   center fold. Sits above the page content but below the toolbar/handles
   (which live inside .page-editor at their own stacking context), and
   ignores clicks so it never blocks slot/text interaction underneath. */
.page-spread::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 48px;
  transform: translateX(-50%);
  pointer-events: none;
  z-index: 4;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.10) 38%,
    rgba(0, 0, 0, 0.16) 50%,
    rgba(0, 0, 0, 0.10) 62%,
    rgba(0, 0, 0, 0) 100%
  );
}

.page-number {
  position: absolute;
  top: -28px;
  left: 0;
  color: #718096;
  font-size: 13px;
  font-weight: 500;
}

.page-content {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
}

.page-dimensions {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(45, 55, 72, 0.85);
  color: #fff;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  pointer-events: none;
}

/* Photo slots */
.photo-slot {
  position: absolute;
  background: #edf2f7;
  border: 2px dashed #cbd5e0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Only hover/selection affordances ease - NOT left/top/width/height, which
     are updated live on every drag tick. Transitioning those made resize,
     move and rotate drags visibly lag behind the cursor (each tick chased
     the previous one over 0.2s instead of tracking it 1:1). */
  transition: background-color 0.2s ease, border-color 0.2s ease;
  overflow: hidden;
  /* Performance optimizations */
  contain: layout style paint;
  will-change: contents;
}

.photo-slot:not(.has-image):hover {
  background: #e2e8f0;
  border-color: #2d3748;
}

.photo-slot:not(.has-image):active {
  background: #cbd5e0;
  transform: scale(0.99);
}

.photo-slot.drag-over {
  background: #e2e8f0;
  border-color: #2d3748;
  border-style: solid;
}

.photo-slot.has-image {
  border: none;
}

.slot-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: #a0aec0;
  pointer-events: none;
}

.photo-slot:not(.has-image):hover .slot-placeholder {
  color: #2d3748;
}

.slot-icon {
  font-size: 24px;
}

.slot-text {
  font-size: 11px;
  text-align: center;
  font-weight: 500;
}

/* Slot image wrapper - clips the photo */
.slot-image-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

/* The actual image element inside slot */
.slot-image-element {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: none;
  transform-origin: center center;
}

.photo-slot.slot-selected {
  outline: 2px dashed #667eea;
  outline-offset: 0px;
  z-index: 10;
  overflow: visible !important;
}

/* Resize handles */
.resize-handle {
  position: absolute;
  width: 12px;
  height: 12px;
  background: white;
  border: 2px solid #667eea;
  border-radius: 2px;
  z-index: 20;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

.handle-n  { top: -6px; left: 50%; transform: translateX(-50%); cursor: n-resize; }
.handle-ne { top: -6px; right: -6px; cursor: ne-resize; }
.handle-e  { top: 50%; right: -6px; transform: translateY(-50%); cursor: e-resize; }
.handle-se { bottom: -6px; right: -6px; cursor: se-resize; }
.handle-s  { bottom: -6px; left: 50%; transform: translateX(-50%); cursor: s-resize; }
.handle-sw { bottom: -6px; left: -6px; cursor: sw-resize; }
.handle-w  { top: 50%; left: -6px; transform: translateY(-50%); cursor: w-resize; }
.handle-nw { top: -6px; left: -6px; cursor: nw-resize; }

/* Free-rotate handle - a curved-arrow badge just outside the bottom-right
   corner, matching Canva's own rotate handle placement/icon. Dragging it
   around the slot's center sets the photo's rotation to any angle (see
   handleRotateStart / the 'rotateDrag' branch in PagesManager.js),
   separate from the 90°-step buttons in .slot-zoom-bar. */
.rotate-handle {
  position: absolute;
  bottom: -26px;
  right: -26px;
  width: 22px;
  height: 22px;
  background: white;
  border: 2px solid #667eea;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  line-height: 1;
  color: #667eea;
  cursor: grab;
  z-index: 20;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
  user-select: none;
  -webkit-user-select: none;
}

.rotate-handle:active {
  cursor: grabbing;
}

/* Move handle - drag to move/resize the whole slot frame on the page
   (different from dragging the photo itself, which pans the image inside
   a fixed frame). Kept off-center, in a corner, so it doesn't sit right on
   top of the natural "grab the photo to reposition it" gesture — it used
   to be dead-center and intercepted every attempt to pan the image. */
.slot-move-handle {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, 0.55);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  z-index: 20;
  font-size: 18px;
  user-select: none;
  -webkit-user-select: none;
  box-shadow: 0 2px 6px rgba(0,0,0,0.4);
  transition: background 0.15s;
}

.slot-move-handle:hover {
  background: rgba(0, 0, 0, 0.75);
}

/* Zoom controls bar on selected slot */
.slot-zoom-bar {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(0, 0, 0, 0.72);
  color: white;
  border-radius: 20px;
  padding: 3px 8px;
  font-size: 11px;
  z-index: 20;
  white-space: nowrap;
  pointer-events: all;
}

.slot-zoom-bar button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  padding: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.slot-zoom-bar button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.remove-image-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  background: #e53e3e;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  transition: opacity 0.2s ease;
  z-index: 21;
}

.photo-slot:hover .remove-image-btn,
.photo-slot.slot-selected .remove-image-btn {
  opacity: 1;
}

.remove-image-btn:hover {
  background: #c0392b;
  transform: scale(1.1);
}

/* Mobile: always show remove button */
@media (max-width: 768px), (hover: none) {
  .remove-image-btn {
    opacity: 1;
    width: 10px;
    height: 10px;
    font-size: 12px;
  }
}

/* Page thumbnails */
.pages-thumbnails {
  display: flex;
  gap: 12px;
  padding: 15px;
  background: #2d3748;
  border-radius: 10px;
  overflow-x: auto;
  flex-shrink: 0;
  max-width: 100%;
  /* Performance optimizations */
  transform: translateZ(0);
  -webkit-overflow-scrolling: touch;
}

/* Custom scrollbar for thumbnails */
.pages-thumbnails::-webkit-scrollbar {
  height: 8px;
}

.pages-thumbnails::-webkit-scrollbar-track {
  background: #1a202c;
  border-radius: 4px;
}

.pages-thumbnails::-webkit-scrollbar-thumb {
  background: #4a5568;
  border-radius: 4px;
}

.pages-thumbnails::-webkit-scrollbar-thumb:hover {
  background: #667eea;
}

.page-thumbnail {
  flex-shrink: 0;
  width: 80px;
  cursor: pointer;
  transition: all 0.2s ease;
  /* touch-action left at its default (auto) so the strip swipe-scrolls
     natively on mobile — drag-reorder is mouse-only (see PagesManager.js),
     touch-action:none previously blocked native scroll for touch drags. */
}

.page-thumbnail:hover {
  transform: translateY(-3px);
}

.page-thumbnail.dragging {
  opacity: 0.35;
  transform: scale(0.93);
}

.page-thumbnail.drag-over .thumbnail-preview {
  outline: 2px dashed #667eea;
  outline-offset: 3px;
}

.page-thumbnail.drag-over .thumbnail-label {
  color: #667eea;
}

.page-thumbnail.active .thumbnail-preview {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

/* Combined "Page 2-3" thumbnail card — two mini previews side by side,
   double the width of a single page thumbnail. .thumbnail-preview's
   active/drag-over outline rules above already apply to both, being plain
   descendant selectors. */
.spread-thumbnail {
  width: 158px;
}

.spread-thumbnail-pair {
  display: flex;
  gap: 2px;
  width: 100%;
}

.spread-thumbnail-pair .thumbnail-preview {
  width: auto;
  flex: 1 1;
}

.thumbnail-preview {
  width: 100%;
  aspect-ratio: 210 / 297;
  background: #fff;
  border-radius: 3px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.thumbnail-slot {
  position: absolute;
  background: #ddd;
  border-radius: 2px;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  /* Performance optimizations */
  contain: strict;
  content-visibility: auto;
}

.thumbnail-slot.filled {
  background-color: transparent;
  /* GPU acceleration for images */
  transform: translateZ(0);
}

.thumbnail-label {
  display: block;
  text-align: center;
  color: #888;
  font-size: 11px;
  margin-top: 5px;
}

.add-page-thumbnail {
  flex-shrink: 0;
  width: 80px;
  aspect-ratio: 210 / 297;
  background: rgba(255, 255, 255, 0.05);
  border: 2px dashed #444;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.add-page-thumbnail:hover {
  background: rgba(102, 126, 234, 0.1);
  border-color: #667eea;
}

.add-page-thumbnail span {
  font-size: 30px;
  color: #666;
}

/* ── Cover integrated inside PagesManager ── */

/* When cover is active, hide PhotoLibrary sidebar */
.pages-manager.cover-active .photo-library {
  display: none;
}

/* Large cover preview fills the entire stage */
.cover-in-pages-large {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Hidden page container (when cover active) */
.current-page-container.hidden {
  display: none;
}

/* Cover thumbnail — matches page-thumbnail style but with cover ratio */
.page-thumbnail .thumbnail-preview.cover-thumbnail-preview {
  aspect-ratio: 33 / 48;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
}

.page-thumbnail.active .thumbnail-preview.cover-thumbnail-preview {
  outline: 2px solid #9e9e9e;
  outline-offset: 2px;
}

.cover-thumb-title {
  font-size: 8px;
  font-weight: 900;
  text-align: center;
  line-height: 1;
  padding: 0 4px;
  letter-spacing: 0.03em;
}

/* Responsive */
/* .photo-library (and the other page-info blocks alongside it) get
   portalled into the full-screen mobile drawer (PhotoBookDesigner.js)
   whenever \`isMobile\` is true there, which is computed at a 1100px
   breakpoint - NOT the 900px breakpoint historically used below for the
   canvas's own row->column collapse. Between 901-1100px that mismatch left
   the drawer open (JS) while \`.photo-library\` still carried its desktop
   fixed-width column styling (240-320px), squeezing "My Photos" into a
   narrow strip inside an otherwise full-width drawer with a large empty
   gap beside it. These rules are keyed to the drawer's real 1100px
   breakpoint so they always match whichever mode is actually active. */
@media (max-width: 1100px) {
  .pages-main {
    padding: 8px 6px;
  }

  .pages-secondary-panel {
    padding: 0;
    gap: 12px;
  }

  .page-limit-info,
  .page-bg-colors {
    width: 100%;
    box-sizing: border-box;
    flex-wrap: wrap;
  }

  .photo-library {
    width: 100%;
    min-width: 0;
    max-width: none;
    height: auto;
    max-height: none;
    padding: 0;
    box-sizing: border-box;
    background: none;
    border-right: none;
    overflow: visible;
  }

  .library-header {
    padding-bottom: 12px;
  }

  .library-photos {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    max-height: none;
    overflow-y: visible;
    padding: 10px 5px;
  }

  .library-photo {
    width: 100%;
    height: auto;
    aspect-ratio: 1;
    min-width: 50px;
    flex-shrink: 0;
  }
}

@media (max-width: 900px) {
  .pages-manager {
    flex-direction: column;
    position: relative;
    /* Fills the space below the header and above the fixed proceed bar, so
       the canvas is visible immediately — no more scrolling past the photo
       library/stats to reach it (those moved into the drawer). A small
       internal scroll on .pages-main is kept as a safety net for taller
       devices/content, rather than the whole page scrolling. */
    height: calc(100vh - 80px - 76px);
    max-height: none;
    min-height: 0;
    overflow: hidden;
  }

  .pages-main {
    height: 100%;
    max-height: none;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px;
    display: flex;
    flex-direction: column;
  }

  .current-page-container {
    overflow: visible;
    flex: 1 1;
    min-height: 350px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  /* On mobile: text panel goes below the page as horizontal scrollable bar */
  .text-panel-vertical {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    flex-direction: row;
    flex-wrap: nowrap;
    align-self: auto;
    padding: 8px 10px;
    gap: 8px;
    overflow-x: auto;
    border-radius: 8px;
  }

  .text-panel-section {
    flex-shrink: 0;
    min-width: fit-content;
  }

  .text-panel-label {
    white-space: nowrap;
    font-size: 8px;
  }

  .text-panel-select {
    min-width: 90px;
    font-size: 11px;
  }

  .text-panel-size {
    min-width: 44px;
    font-size: 12px;
  }

  .text-panel-row {
    gap: 3px;
  }

  .text-panel-btn {
    min-width: 28px;
    padding: 5px 6px;
    font-size: 13px;
  }

  .text-panel-btn-apply {
    min-width: 80px;
    font-size: 10px;
    padding: 6px 8px;
    word-break: normal;
  }

  .text-panel-btn-delete {
    min-width: 80px;
    font-size: 11px;
    padding: 6px 8px;
  }
  
  .layouts-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  /* Layout picker fixed at bottom on mobile */
  .layout-picker-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
  }
  
  .layout-picker {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -4px 20px rgba(0,0,0,0.15);
    max-height: 60vh;
    overflow-y: auto;
    animation: slideUp 0.3s ease;
  }
  
  .layout-picker-close {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
  
  /* Page thumbnails scrollable on mobile */
  .pages-thumbnails {
    overflow-x: auto;
    padding: 10px;
    gap: 10px;
  }
  
  .page-thumbnail {
    flex-shrink: 0;
  }
  
  /* Current page container smaller on mobile */
  .current-page-container {
    padding: 10px;
  }
  
  .page-editor {
    max-width: 280px;
  }
}

/* Small phone screens */
@media (max-width: 600px) {
  .library-photos {
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }
  
  .library-photo {
    min-width: 40px;
  }
  
  .page-editor {
    max-width: 240px;
  }
  
  .current-page-container {
    min-height: 300px;
    max-height: 45vh;
  }
  
  .pages-thumbnails {
    padding: 8px;
    gap: 8px;
  }
  
  .page-thumbnail {
    width: 60px;
  }

  .spread-thumbnail {
    width: 118px;
  }
}

/* AI Generate Button */
.ai-generate-btn {
  padding: 10px 15px;
  background: linear-gradient(135deg, #ff36f2 0%, #70eaeb 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.ai-generate-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.ai-generate-btn:active {
  transform: translateY(0);
}

.ai-generate-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* AI Loading Overlay */
.ai-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.98);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(8px);
}

.ai-loading-content {
  text-align: center;
  padding: 40px;
}

/* AI Star Spinner Animation */
.ai-spinner {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto 30px;
}

.ai-star {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-star svg {
  width: 60px;
  height: 60px;
  animation: starPulse 2s ease-in-out infinite;
}

.ai-star svg path {
  fill: #2d3748;
}

/* Sparkle particles */
.sparkle {
  position: absolute;
  width: 8px;
  height: 8px;
  background: #2d3748;
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  animation: sparkleFloat 2s ease-in-out infinite;
}

.sparkle:nth-child(1) {
  top: 5px;
  left: 50%;
  animation-delay: 0s;
}

.sparkle:nth-child(2) {
  top: 25%;
  right: 5px;
  animation-delay: 0.3s;
}

.sparkle:nth-child(3) {
  bottom: 25%;
  right: 10px;
  animation-delay: 0.6s;
}

.sparkle:nth-child(4) {
  bottom: 5px;
  left: 50%;
  animation-delay: 0.9s;
}

.sparkle:nth-child(5) {
  top: 25%;
  left: 5px;
  animation-delay: 1.2s;
}

.sparkle:nth-child(6) {
  bottom: 25%;
  left: 10px;
  animation-delay: 1.5s;
}

@keyframes starPulse {
  0%, 100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  25% {
    transform: scale(1.1) rotate(15deg);
    opacity: 0.9;
  }
  50% {
    transform: scale(0.95) rotate(-10deg);
    opacity: 1;
  }
  75% {
    transform: scale(1.05) rotate(5deg);
    opacity: 0.95;
  }
}

@keyframes sparkleFloat {
  0%, 100% {
    transform: scale(0.5) translateY(0);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.2) translateY(-5px);
    opacity: 1;
  }
}

/* Orbiting dots */
.orbit-container {
  position: absolute;
  width: 100%;
  height: 100%;
  animation: orbitSpin 4s linear infinite;
}

.orbit-dot {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #4a5568;
  border-radius: 50%;
}

.orbit-dot:nth-child(1) {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.orbit-dot:nth-child(2) {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.orbit-dot:nth-child(3) {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.orbit-dot:nth-child(4) {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

@keyframes orbitSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ai-loading-text {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 10px 0;
  letter-spacing: 0.5px;
}

.ai-loading-subtext {
  font-size: 14px;
  color: #718096;
  margin: 0;
}

/* Large screens - wider photo library and bigger pages */
@media (min-width: 1400px) {
  .photo-library {
    width: 320px;
    min-width: 320px;
    max-width: 320px;
  }
  
  .library-photos {
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
  }
  
  .page-editor {
    max-width: 400px;
  }
  
  .current-page-container {
    min-height: 550px;
  }
}

/* Medium laptop screens */
@media (min-width: 1100px) and (max-width: 1399px) {
  .photo-library {
    width: 280px;
    min-width: 280px;
    max-width: 280px;
  }
  
  .library-photos {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
  
  .page-editor {
    max-width: 350px;
  }
}

/* Small laptop screens. NOTE: .photo-library itself is NOT sized here -
   at this width the mobile drawer is already active (see the ≤1100px
   block above, matching PhotoBookDesigner.js's \`isMobile\` breakpoint), so
   any fixed-column width set here would only fight with the drawer's
   full-width treatment. Only .page-editor (the canvas page itself, still
   rendered in-flow, not portalled) has a real width at this breakpoint. */
@media (min-width: 901px) and (max-width: 1099px) {
  .page-editor {
    max-width: 300px;
  }
}

/* ===== TEXT ELEMENTS ON PAGE ===== */
.text-element {
  position: absolute;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
  border-radius: 3px;
  min-width: 60px;
  min-height: 24px;
}

.text-element-selected {
  outline: 2px dashed #667eea;
  outline-offset: 4px;
  background: rgba(102, 126, 234, 0.06);
  z-index: 30 !important;
}

/* Text formatting toolbar */
.text-toolbar {
  position: absolute;
  top: -52px;
  left: 50%;
  transform: translateX(-50%);
  background: #1a202c;
  border-radius: 8px;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  z-index: 100;
  box-shadow: 0 4px 16px rgba(0,0,0,0.35);
  flex-wrap: nowrap;
  overflow: visible;
}

.text-font-select {
  background: #2d3748;
  color: #fff;
  border: 1px solid #4a5568;
  border-radius: 4px;
  padding: 3px 5px;
  font-size: 11px;
  cursor: pointer;
  max-width: 110px;
}

.text-font-select:focus {
  outline: none;
  border-color: #667eea;
}

.text-size-input {
  background: #2d3748;
  color: #fff;
  border: 1px solid #4a5568;
  border-radius: 4px;
  padding: 3px 4px;
  font-size: 11px;
  width: 42px;
  text-align: center;
}

.text-size-input:focus {
  outline: none;
  border-color: #667eea;
}

.text-color-input {
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  background: none;
}

.text-toolbar-divider {
  width: 1px;
  height: 20px;
  background: #4a5568;
  margin: 0 2px;
  flex-shrink: 0;
}

.text-btn {
  background: transparent;
  color: #e2e8f0;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 3px 7px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
  line-height: 1;
}

.text-btn:hover {
  background: #2d3748;
  border-color: #4a5568;
}

.text-btn.active {
  background: #667eea;
  border-color: #667eea;
  color: #fff;
}

.text-btn-delete {
  color: #fc8181;
}

.text-btn-delete:hover {
  background: #c53030;
  border-color: #c53030;
  color: #fff;
}

.text-btn-apply-all {
  background: #38a169;
  border-color: #38a169;
  color: #fff;
  font-size: 10px;
  padding: 3px 8px;
  white-space: nowrap;
}

.text-btn-apply-all:hover {
  background: #2f855a;
  border-color: #2f855a;
}

/* Text editing textarea */
.text-edit-input {
  width: 100%;
  min-height: 40px;
  background: rgba(255,255,255,0.9);
  border: 1px solid #667eea;
  border-radius: 3px;
  resize: both;
  padding: 4px;
  outline: none;
  box-sizing: border-box;
}

/* Mobile: text toolbar adjustments */
@media (max-width: 768px) {
  .text-toolbar {
    top: -58px;
    padding: 5px 6px;
    gap: 3px;
    max-width: 98vw;
    overflow-x: auto;
  }

  .text-font-select {
    max-width: 80px;
    font-size: 10px;
  }

  .text-size-input {
    width: 36px;
    font-size: 10px;
  }

  .text-btn {
    padding: 3px 5px;
    font-size: 11px;
  }

  .text-btn-apply-all {
    font-size: 9px;
    padding: 3px 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PhotoBook/PagesManager.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,MAAM;EACN,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;;;;iDAQiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mDAAmD;EACnD,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,uCAAuC;AACvC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf;qBACmB;;EAEnB,8BAA8B;EAC9B;;8BAE4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;GAIG;;;AAGH;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B;sCACoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;yDAIyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,2BAA2B,aAAa,EAAE,qBAAqB,EAAE;;AAEjE;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,yBAAyB,aAAa,EAAE,qBAAqB,EAAE;;AAE/D;EACE,SAAO;EACP,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA,wBAAwB,mBAAmB,EAAE;AAC7C,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;;AAElF;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA,+BAA+B,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;;AAExF,gBAAgB;AAChB;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB,EAAE,aAAa;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;wEAIwE;AACxE;EACE,aAAa;EACb,MAAM;EACN,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,SAAW;EACX,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;wEAGwE;AACxE;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;EACpB,UAAU;EACV;;;;;;;GAOC;AACH;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kCAAkC;EAClC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;8DAG4D;EAC5D,8DAA8D;EAC9D,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,qCAAqC;AACvC;;AAEA,aAAa,SAAS,EAAE,SAAS,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AAClF,aAAa,SAAS,EAAE,WAAW,EAAE,iBAAiB,EAAE;AACxD,aAAa,QAAQ,EAAE,WAAW,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AACnF,aAAa,YAAY,EAAE,WAAW,EAAE,iBAAiB,EAAE;AAC3D,aAAa,YAAY,EAAE,SAAS,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AACrF,aAAa,YAAY,EAAE,UAAU,EAAE,iBAAiB,EAAE;AAC1D,aAAa,QAAQ,EAAE,UAAU,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AAClF,aAAa,SAAS,EAAE,UAAU,EAAE,iBAAiB,EAAE;;AAEvD;;;;0DAI0D;AAC1D;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;sEAIsE;AACtE;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,qCAAqC;EACrC,6BAA6B;EAC7B,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,oCAAoC;AACpC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB;;0EAEwE;AAC1E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;0BAG0B;AAC1B;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,+CAA+C;;AAE/C,oDAAoD;AACpD;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;AACf;;AAEA,wEAAwE;AACxE;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA,eAAe;AACf;;;;;;;;;uEASuE;AACvE;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB;;;;+DAI2D;IAC3D,iCAAiC;IACjC,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,SAAO;IACP,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA,2EAA2E;EAC3E;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;;EAEA,4CAA4C;EAC5C;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,4BAA4B;IAC5B,wCAAwC;IACxC,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;EACF;;EAEA,yCAAyC;EACzC;IACE,gBAAgB;IAChB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA,6CAA6C;EAC7C;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,0GAA0G;EAC1G,+CAA+C;AACjD;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE;IACE,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,mCAAmC;IACnC,YAAY;EACd;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,mCAAmC;IACnC,aAAa;EACf;AACF;;AAEA;EACE;IACE,mCAAmC;IACnC,YAAY;EACd;EACA;IACE,sCAAsC;IACtC,UAAU;EACZ;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,yDAAyD;AACzD;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;;0EAK0E;AAC1E;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;EACvC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,QAAQ;IACR,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":[".textiAI{\n  color: lightblue;\n}\n\n.mesazhi-per-foto{\n  color: rgb(51, 158, 230);\n}\n\n/* Pages Manager Styles - Clean Professional Design */\n.pages-manager {\n  display: flex;\n  gap: 0;\n  min-height: 600px;\n  max-height: 85vh;\n  background: #f8f9fa;\n  overflow: hidden;\n  width: 100%;\n  max-width: 100%;\n}\n\n/* Wraps page-limit-info + page-bg-colors + PhotoLibrary into ONE flex-row\n   column (previously these were 3 unwrapped siblings each competing\n   independently for width in .pages-manager's flex row, which is what let\n   them collectively starve .pages-main - the canvas - down to as little as\n   30px wide on common laptop screens; see PagesManager.js). flex-shrink:0\n   plus no explicit width lets it size to its widest child (.photo-library's\n   own fixed width below), and the column's default `align-items: stretch`\n   makes page-limit-info/page-bg-colors automatically match that width\n   instead of each claiming their own row slot. */\n.pages-secondary-panel {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  gap: 12px;\n  padding: 12px 0 12px 12px;\n}\n\n/* Photo Library Sidebar */\n.photo-library {\n  width: 280px;\n  min-width: 280px;\n  max-width: 280px;\n  background: #ffffff;\n  border-right: 1px solid #e2e8f0;\n  padding: 15px 12px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 85vh;\n  overflow: hidden;\n}\n\n.library-header {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.library-header h4 {\n  color: #2d3748;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.photo-count-badge {\n  background: #667eea;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 10px;\n  min-width: 20px;\n  text-align: center;\n}\n\n.add-photos-btn {\n  padding: 10px 15px;\n  background: #2d3748;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.add-photos-btn:hover {\n  background: #1a202c;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n}\n\n.add-photos-phone-btn {\n  padding: 10px 15px;\n  background: transparent;\n  color: #2d3748;\n  border: 1.5px solid #cbd5e0;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.add-photos-phone-btn:hover:not(:disabled) {\n  border-color: #2d3748;\n  background: #f7fafc;\n}\n\n/* ── Mobile pairing (QR / link) modal ── */\n.mobile-pairing-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2100;\n  background: rgba(20, 20, 24, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.mobile-pairing-card {\n  position: relative;\n  width: 100%;\n  max-width: 340px;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n  padding: 28px 24px 24px;\n  text-align: center;\n}\n\n.mobile-pairing-close {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  background: none;\n  border: none;\n  font-size: 22px;\n  line-height: 1;\n  color: #718096;\n  cursor: pointer;\n}\n\n.mobile-pairing-card h3 {\n  margin: 0 0 6px;\n  font-size: 17px;\n  color: #1a202c;\n}\n\n.mobile-pairing-subtitle {\n  margin: 0 0 18px;\n  font-size: 13px;\n  color: #718096;\n}\n\n.mobile-pairing-qr {\n  display: flex;\n  justify-content: center;\n  padding: 12px;\n  background: #f7fafc;\n  border-radius: 12px;\n  margin-bottom: 16px;\n}\n\n.mobile-pairing-link-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.mobile-pairing-link-row input {\n  flex: 1;\n  min-width: 0;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 11px;\n  color: #4a5568;\n  background: #f7fafc;\n}\n\n.mobile-pairing-link-row button {\n  padding: 8px 14px;\n  background: #2d3748;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.mobile-pairing-status {\n  margin: 0;\n  font-size: 13px;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.library-photos {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n  padding: 8px;\n  min-height: 0;\n  /* Performance optimizations for smooth scrolling */\n  transform: translateZ(0);\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Custom scrollbar for photo library */\n.library-photos::-webkit-scrollbar {\n  width: 6px;\n}\n\n.library-photos::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.library-photos::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.library-photos::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n}\n\n.library-photo {\n  position: relative;\n  aspect-ratio: 1;\n  /* border-radius: 6px;\n  overflow: hidden; */\n\n  /* Performance optimizations */\n  /* contain: layout style paint;\n  will-change: transform;\n  transition: all 0.2s ease; */\n}\n\n.library-photo-delete {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.65);\n  color: #fff;\n  font-size: 14px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.library-photo-delete:hover {\n  background: #e53e3e;\n}\n\n/* .library-photo:hover {\n  border-color: #667eea;\n  transform: scale(1.02);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n} */\n\n\n.library-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  /* Performance optimizations */\n  /* content-visibility: auto;\n  contain-intrinsic-size: 80px 80px; */\n}\n\n.empty-library {\n  grid-column: span 2;\n  text-align: center;\n  padding: 30px 10px;\n  color: #a0aec0;\n}\n\n.empty-library span {\n  font-size: 36px;\n  display: block;\n  margin-bottom: 10px;\n  opacity: 0.5;\n}\n\n.empty-library p {\n  font-size: 12px;\n  margin: 0;\n  color: #718096;\n}\n\n.pages-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: #f8f9fa;\n  padding: 15px;\n  gap: 12px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 85vh;\n}\n\n/* Toolbar */\n.pages-toolbar {\n  display: flex;\n  gap: 10px;\n  padding: 12px 15px;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n  border: 1px solid #e2e8f0;\n}\n\n.toolbar-action {\n  padding: 10px 16px;\n  background: #ffffff;\n  color: #2d3748;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.toolbar-action:hover {\n  background: #f7fafc;\n  border-color: #2d3748;\n}\n\n.toolbar-action.danger {\n  color: #e53e3e;\n  border-color: #feb2b2;\n}\n\n.toolbar-action.danger:hover {\n  background: #fff5f5;\n  border-color: #e53e3e;\n}\n\n.toolbar-action.disabled,\n.toolbar-action:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* Page limit info. flex-shrink + min-width:0 + flex-wrap let this actually\n   shrink/wrap its text instead of forcing its full single-line content\n   width, which is what was starving .pages-main of space (see comment\n   there) at common laptop widths - it's a flex ROW child of\n   .pages-manager just like .photo-library/.pages-main. */\n.page-limit-info {\n  display: flex;\n  align-items: center;\n  flex-shrink: 1;\n  min-width: 0;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 10px 15px;\n  background: #edf2f7;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n.page-limit-info .info-icon {\n  font-size: 14px;\n}\n\n.page-limit-info span {\n  color: #4a5568;\n  font-size: 13px;\n}\n\n/* Layout picker */\n.layout-picker-overlay {\n  display: none;\n}\n\n.layout-picker {\n  background: #ffffff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.layout-picker-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.layout-picker h4 {\n  color: #2d3748;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.layout-picker-close {\n  display: none;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: #f0f0f0;\n  border-radius: 50%;\n  font-size: 20px;\n  cursor: pointer;\n  color: #666;\n  transition: all 0.2s;\n}\n\n.layout-picker-close:hover {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.layouts-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.layout-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 8px;\n  background: #f7fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.layout-option:hover {\n  background: #edf2f7;\n  border-color: #2d3748;\n}\n\n.layout-option.active {\n  background: #2d3748;\n  border-color: #2d3748;\n}\n\n.layout-option.active .layout-icon,\n.layout-option.active .layout-name {\n  color: white;\n}\n\n.layout-icon {\n  font-size: 18px;\n  color: #2d3748;\n  white-space: pre-line;\n  line-height: 1.2;\n}\n\n.layout-name {\n  font-size: 10px;\n  color: #718096;\n  text-align: center;\n}\n\n/* Page background colors */\n.page-bg-colors {\n  display: flex;\n  align-items: center;\n  flex-shrink: 1;\n  min-width: 0;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 10px 15px;\n  background: #ffffff;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n.page-bg-colors span {\n  color: #718096;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.page-color-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.page-color-btn:hover {\n  transform: scale(1.1);\n  border-color: #a0aec0;\n}\n\n.page-color-btn.active {\n  border-color: #2d3748;\n  box-shadow: 0 0 0 2px rgba(45, 55, 72, 0.2);\n}\n\n/* Current page container */\n.current-page-container {\n  flex: 1;\n  width: 100%;\n  max-width: 700px;\n  align-self: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  min-height: 400px;\n  max-height: 55vh;\n  overflow: hidden;\n  gap: 16px;\n}\n\n/* Vertical text panel */\n.text-panel-vertical {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  background: #1a202c;\n  border-radius: 10px;\n  padding: 10px 6px;\n  width: 68px;\n  min-width: 68px;\n  max-width: 68px;\n  align-self: stretch;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.25);\n  flex-shrink: 0;\n}\n\n.text-panel-label {\n  display: block;\n  color: #a0aec0;\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  margin-bottom: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.text-panel-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.text-panel-row {\n  display: flex;\n  gap: 2px;\n}\n\n.text-panel-select {\n  background: #2d3748;\n  color: #fff;\n  border: 1px solid #4a5568;\n  border-radius: 5px;\n  padding: 3px 2px;\n  font-size: 10px;\n  width: 100%;\n  cursor: pointer;\n}\n\n.text-panel-select:focus { outline: none; border-color: #667eea; }\n\n.text-panel-size {\n  background: #2d3748;\n  color: #fff;\n  border: 1px solid #4a5568;\n  border-radius: 5px;\n  padding: 3px 2px;\n  font-size: 11px;\n  width: 100%;\n  text-align: center;\n}\n\n.text-panel-size:focus { outline: none; border-color: #667eea; }\n\n.text-panel-btn {\n  flex: 1;\n  background: #2d3748;\n  color: #e2e8f0;\n  border: 1px solid #4a5568;\n  border-radius: 5px;\n  padding: 4px 2px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n  min-width: 0;\n}\n\n.text-panel-btn:hover { background: #4a5568; }\n.text-panel-btn.active { background: #667eea; border-color: #667eea; color: #fff; }\n\n.text-panel-color {\n  width: 100%;\n  height: 28px;\n  border: 1px solid #4a5568;\n  border-radius: 5px;\n  cursor: pointer;\n  padding: 0;\n  background: none;\n}\n\n.text-panel-btn-apply {\n  background: #38a169;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 5px 2px;\n  font-size: 9px;\n  cursor: pointer;\n  width: 100%;\n  transition: background 0.15s;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.text-panel-btn-apply:hover { background: #2f855a; }\n\n.text-panel-btn-delete {\n  background: transparent;\n  color: #fc8181;\n  border: 1px solid #fc8181;\n  border-radius: 5px;\n  padding: 5px 4px;\n  font-size: 11px;\n  cursor: pointer;\n  width: 100%;\n  transition: all 0.15s;\n}\n\n.text-panel-btn-delete:hover { background: #c53030; border-color: #c53030; color: #fff; }\n\n/* Page editor */\n.page-editor {\n  width: 100%;\n  max-width: 320px;\n  aspect-ratio: 210 / 297; /* A4 ratio */\n  position: relative;\n  border-radius: 4px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  background: #fff;\n}\n\n.page-editor.selected {\n  outline-offset: 5px;\n}\n\n/* Open-book spread (desktop/tablet only — PagesManager renders a single\n   .page-editor instead on mobile). The two pages butt together (no gap)\n   and share ONE outer shadow/rounding, like a single open book, instead of\n   each page looking like its own separate card; a gradient \"gutter\" shadow\n   is overlaid at the seam (::after below) to read as the book's fold. */\n.page-spread {\n  display: flex;\n  gap: 0;\n  align-items: stretch;\n  justify-content: center;\n  width: 100%;\n  max-width: 640px;\n  position: relative;\n  border-radius: 4px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.18);\n}\n\n.page-spread .page-editor,\n.page-spread-blank {\n  flex: 1 1 0;\n  width: auto;\n  max-width: none;\n  aspect-ratio: 210 / 297;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.page-spread .page-editor:first-child,\n.page-spread-blank:first-child {\n  border-radius: 4px 0 0 4px;\n}\n\n.page-spread .page-editor:last-child,\n.page-spread-blank:last-child {\n  border-radius: 0 4px 4px 0;\n}\n\n.page-spread-blank {\n  background: #fdfdfb;\n}\n\n/* Gutter shadow — the soft dark seam a real open book casts down its\n   center fold. Sits above the page content but below the toolbar/handles\n   (which live inside .page-editor at their own stacking context), and\n   ignores clicks so it never blocks slot/text interaction underneath. */\n.page-spread::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  width: 48px;\n  transform: translateX(-50%);\n  pointer-events: none;\n  z-index: 4;\n  background: linear-gradient(\n    to right,\n    rgba(0, 0, 0, 0) 0%,\n    rgba(0, 0, 0, 0.10) 38%,\n    rgba(0, 0, 0, 0.16) 50%,\n    rgba(0, 0, 0, 0.10) 62%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n.page-number {\n  position: absolute;\n  top: -28px;\n  left: 0;\n  color: #718096;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.page-content {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background: #fff;\n}\n\n.page-dimensions {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background: rgba(45, 55, 72, 0.85);\n  color: #fff;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 500;\n  pointer-events: none;\n}\n\n/* Photo slots */\n.photo-slot {\n  position: absolute;\n  background: #edf2f7;\n  border: 2px dashed #cbd5e0;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Only hover/selection affordances ease - NOT left/top/width/height, which\n     are updated live on every drag tick. Transitioning those made resize,\n     move and rotate drags visibly lag behind the cursor (each tick chased\n     the previous one over 0.2s instead of tracking it 1:1). */\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n  overflow: hidden;\n  /* Performance optimizations */\n  contain: layout style paint;\n  will-change: contents;\n}\n\n.photo-slot:not(.has-image):hover {\n  background: #e2e8f0;\n  border-color: #2d3748;\n}\n\n.photo-slot:not(.has-image):active {\n  background: #cbd5e0;\n  transform: scale(0.99);\n}\n\n.photo-slot.drag-over {\n  background: #e2e8f0;\n  border-color: #2d3748;\n  border-style: solid;\n}\n\n.photo-slot.has-image {\n  border: none;\n}\n\n.slot-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  color: #a0aec0;\n  pointer-events: none;\n}\n\n.photo-slot:not(.has-image):hover .slot-placeholder {\n  color: #2d3748;\n}\n\n.slot-icon {\n  font-size: 24px;\n}\n\n.slot-text {\n  font-size: 11px;\n  text-align: center;\n  font-weight: 500;\n}\n\n/* Slot image wrapper - clips the photo */\n.slot-image-wrapper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n/* The actual image element inside slot */\n.slot-image-element {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  user-select: none;\n  -webkit-user-select: none;\n  pointer-events: none;\n  transform-origin: center center;\n}\n\n.photo-slot.slot-selected {\n  outline: 2px dashed #667eea;\n  outline-offset: 0px;\n  z-index: 10;\n  overflow: visible !important;\n}\n\n/* Resize handles */\n.resize-handle {\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  background: white;\n  border: 2px solid #667eea;\n  border-radius: 2px;\n  z-index: 20;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.3);\n}\n\n.handle-n  { top: -6px; left: 50%; transform: translateX(-50%); cursor: n-resize; }\n.handle-ne { top: -6px; right: -6px; cursor: ne-resize; }\n.handle-e  { top: 50%; right: -6px; transform: translateY(-50%); cursor: e-resize; }\n.handle-se { bottom: -6px; right: -6px; cursor: se-resize; }\n.handle-s  { bottom: -6px; left: 50%; transform: translateX(-50%); cursor: s-resize; }\n.handle-sw { bottom: -6px; left: -6px; cursor: sw-resize; }\n.handle-w  { top: 50%; left: -6px; transform: translateY(-50%); cursor: w-resize; }\n.handle-nw { top: -6px; left: -6px; cursor: nw-resize; }\n\n/* Free-rotate handle - a curved-arrow badge just outside the bottom-right\n   corner, matching Canva's own rotate handle placement/icon. Dragging it\n   around the slot's center sets the photo's rotation to any angle (see\n   handleRotateStart / the 'rotateDrag' branch in PagesManager.js),\n   separate from the 90°-step buttons in .slot-zoom-bar. */\n.rotate-handle {\n  position: absolute;\n  bottom: -26px;\n  right: -26px;\n  width: 22px;\n  height: 22px;\n  background: white;\n  border: 2px solid #667eea;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  line-height: 1;\n  color: #667eea;\n  cursor: grab;\n  z-index: 20;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.3);\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.rotate-handle:active {\n  cursor: grabbing;\n}\n\n/* Move handle - drag to move/resize the whole slot frame on the page\n   (different from dragging the photo itself, which pans the image inside\n   a fixed frame). Kept off-center, in a corner, so it doesn't sit right on\n   top of the natural \"grab the photo to reposition it\" gesture — it used\n   to be dead-center and intercepted every attempt to pan the image. */\n.slot-move-handle {\n  position: absolute;\n  top: 6px;\n  left: 6px;\n  width: 30px;\n  height: 30px;\n  background: rgba(0, 0, 0, 0.55);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: move;\n  z-index: 20;\n  font-size: 18px;\n  user-select: none;\n  -webkit-user-select: none;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.4);\n  transition: background 0.15s;\n}\n\n.slot-move-handle:hover {\n  background: rgba(0, 0, 0, 0.75);\n}\n\n/* Zoom controls bar on selected slot */\n.slot-zoom-bar {\n  position: absolute;\n  bottom: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(0, 0, 0, 0.72);\n  color: white;\n  border-radius: 20px;\n  padding: 3px 8px;\n  font-size: 11px;\n  z-index: 20;\n  white-space: nowrap;\n  pointer-events: all;\n}\n\n.slot-zoom-bar button {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  font-size: 15px;\n  line-height: 1;\n  padding: 0;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.slot-zoom-bar button:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.remove-image-btn {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 24px;\n  height: 24px;\n  background: #e53e3e;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n  transition: opacity 0.2s ease;\n  z-index: 21;\n}\n\n.photo-slot:hover .remove-image-btn,\n.photo-slot.slot-selected .remove-image-btn {\n  opacity: 1;\n}\n\n.remove-image-btn:hover {\n  background: #c0392b;\n  transform: scale(1.1);\n}\n\n/* Mobile: always show remove button */\n@media (max-width: 768px), (hover: none) {\n  .remove-image-btn {\n    opacity: 1;\n    width: 10px;\n    height: 10px;\n    font-size: 12px;\n  }\n}\n\n/* Page thumbnails */\n.pages-thumbnails {\n  display: flex;\n  gap: 12px;\n  padding: 15px;\n  background: #2d3748;\n  border-radius: 10px;\n  overflow-x: auto;\n  flex-shrink: 0;\n  max-width: 100%;\n  /* Performance optimizations */\n  transform: translateZ(0);\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Custom scrollbar for thumbnails */\n.pages-thumbnails::-webkit-scrollbar {\n  height: 8px;\n}\n\n.pages-thumbnails::-webkit-scrollbar-track {\n  background: #1a202c;\n  border-radius: 4px;\n}\n\n.pages-thumbnails::-webkit-scrollbar-thumb {\n  background: #4a5568;\n  border-radius: 4px;\n}\n\n.pages-thumbnails::-webkit-scrollbar-thumb:hover {\n  background: #667eea;\n}\n\n.page-thumbnail {\n  flex-shrink: 0;\n  width: 80px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  /* touch-action left at its default (auto) so the strip swipe-scrolls\n     natively on mobile — drag-reorder is mouse-only (see PagesManager.js),\n     touch-action:none previously blocked native scroll for touch drags. */\n}\n\n.page-thumbnail:hover {\n  transform: translateY(-3px);\n}\n\n.page-thumbnail.dragging {\n  opacity: 0.35;\n  transform: scale(0.93);\n}\n\n.page-thumbnail.drag-over .thumbnail-preview {\n  outline: 2px dashed #667eea;\n  outline-offset: 3px;\n}\n\n.page-thumbnail.drag-over .thumbnail-label {\n  color: #667eea;\n}\n\n.page-thumbnail.active .thumbnail-preview {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n/* Combined \"Page 2-3\" thumbnail card — two mini previews side by side,\n   double the width of a single page thumbnail. .thumbnail-preview's\n   active/drag-over outline rules above already apply to both, being plain\n   descendant selectors. */\n.spread-thumbnail {\n  width: 158px;\n}\n\n.spread-thumbnail-pair {\n  display: flex;\n  gap: 2px;\n  width: 100%;\n}\n\n.spread-thumbnail-pair .thumbnail-preview {\n  width: auto;\n  flex: 1 1 0;\n}\n\n.thumbnail-preview {\n  width: 100%;\n  aspect-ratio: 210 / 297;\n  background: #fff;\n  border-radius: 3px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.thumbnail-slot {\n  position: absolute;\n  background: #ddd;\n  border-radius: 2px;\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n  /* Performance optimizations */\n  contain: strict;\n  content-visibility: auto;\n}\n\n.thumbnail-slot.filled {\n  background-color: transparent;\n  /* GPU acceleration for images */\n  transform: translateZ(0);\n}\n\n.thumbnail-label {\n  display: block;\n  text-align: center;\n  color: #888;\n  font-size: 11px;\n  margin-top: 5px;\n}\n\n.add-page-thumbnail {\n  flex-shrink: 0;\n  width: 80px;\n  aspect-ratio: 210 / 297;\n  background: rgba(255, 255, 255, 0.05);\n  border: 2px dashed #444;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.add-page-thumbnail:hover {\n  background: rgba(102, 126, 234, 0.1);\n  border-color: #667eea;\n}\n\n.add-page-thumbnail span {\n  font-size: 30px;\n  color: #666;\n}\n\n/* ── Cover integrated inside PagesManager ── */\n\n/* When cover is active, hide PhotoLibrary sidebar */\n.pages-manager.cover-active .photo-library {\n  display: none;\n}\n\n/* Large cover preview fills the entire stage */\n.cover-in-pages-large {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Hidden page container (when cover active) */\n.current-page-container.hidden {\n  display: none;\n}\n\n/* Cover thumbnail — matches page-thumbnail style but with cover ratio */\n.page-thumbnail .thumbnail-preview.cover-thumbnail-preview {\n  aspect-ratio: 33 / 48;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.page-thumbnail.active .thumbnail-preview.cover-thumbnail-preview {\n  outline: 2px solid #9e9e9e;\n  outline-offset: 2px;\n}\n\n.cover-thumb-title {\n  font-size: 8px;\n  font-weight: 900;\n  text-align: center;\n  line-height: 1;\n  padding: 0 4px;\n  letter-spacing: 0.03em;\n}\n\n/* Responsive */\n/* .photo-library (and the other page-info blocks alongside it) get\n   portalled into the full-screen mobile drawer (PhotoBookDesigner.js)\n   whenever `isMobile` is true there, which is computed at a 1100px\n   breakpoint - NOT the 900px breakpoint historically used below for the\n   canvas's own row->column collapse. Between 901-1100px that mismatch left\n   the drawer open (JS) while `.photo-library` still carried its desktop\n   fixed-width column styling (240-320px), squeezing \"My Photos\" into a\n   narrow strip inside an otherwise full-width drawer with a large empty\n   gap beside it. These rules are keyed to the drawer's real 1100px\n   breakpoint so they always match whichever mode is actually active. */\n@media (max-width: 1100px) {\n  .pages-main {\n    padding: 8px 6px;\n  }\n\n  .pages-secondary-panel {\n    padding: 0;\n    gap: 12px;\n  }\n\n  .page-limit-info,\n  .page-bg-colors {\n    width: 100%;\n    box-sizing: border-box;\n    flex-wrap: wrap;\n  }\n\n  .photo-library {\n    width: 100%;\n    min-width: 0;\n    max-width: none;\n    height: auto;\n    max-height: none;\n    padding: 0;\n    box-sizing: border-box;\n    background: none;\n    border-right: none;\n    overflow: visible;\n  }\n\n  .library-header {\n    padding-bottom: 12px;\n  }\n\n  .library-photos {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 10px;\n    max-height: none;\n    overflow-y: visible;\n    padding: 10px 5px;\n  }\n\n  .library-photo {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1;\n    min-width: 50px;\n    flex-shrink: 0;\n  }\n}\n\n@media (max-width: 900px) {\n  .pages-manager {\n    flex-direction: column;\n    position: relative;\n    /* Fills the space below the header and above the fixed proceed bar, so\n       the canvas is visible immediately — no more scrolling past the photo\n       library/stats to reach it (those moved into the drawer). A small\n       internal scroll on .pages-main is kept as a safety net for taller\n       devices/content, rather than the whole page scrolling. */\n    height: calc(100vh - 80px - 76px);\n    max-height: none;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .pages-main {\n    height: 100%;\n    max-height: none;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .current-page-container {\n    overflow: visible;\n    flex: 1;\n    min-height: 350px;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n  }\n\n  /* On mobile: text panel goes below the page as horizontal scrollable bar */\n  .text-panel-vertical {\n    width: 100%;\n    min-width: 100%;\n    max-width: 100%;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-self: auto;\n    padding: 8px 10px;\n    gap: 8px;\n    overflow-x: auto;\n    border-radius: 8px;\n  }\n\n  .text-panel-section {\n    flex-shrink: 0;\n    min-width: fit-content;\n  }\n\n  .text-panel-label {\n    white-space: nowrap;\n    font-size: 8px;\n  }\n\n  .text-panel-select {\n    min-width: 90px;\n    font-size: 11px;\n  }\n\n  .text-panel-size {\n    min-width: 44px;\n    font-size: 12px;\n  }\n\n  .text-panel-row {\n    gap: 3px;\n  }\n\n  .text-panel-btn {\n    min-width: 28px;\n    padding: 5px 6px;\n    font-size: 13px;\n  }\n\n  .text-panel-btn-apply {\n    min-width: 80px;\n    font-size: 10px;\n    padding: 6px 8px;\n    word-break: normal;\n  }\n\n  .text-panel-btn-delete {\n    min-width: 80px;\n    font-size: 11px;\n    padding: 6px 8px;\n  }\n  \n  .layouts-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  /* Layout picker fixed at bottom on mobile */\n  .layout-picker-overlay {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 99;\n  }\n  \n  .layout-picker {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 100;\n    border-radius: 16px 16px 0 0;\n    box-shadow: 0 -4px 20px rgba(0,0,0,0.15);\n    max-height: 60vh;\n    overflow-y: auto;\n    animation: slideUp 0.3s ease;\n  }\n  \n  .layout-picker-close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  @keyframes slideUp {\n    from {\n      transform: translateY(100%);\n    }\n    to {\n      transform: translateY(0);\n    }\n  }\n  \n  /* Page thumbnails scrollable on mobile */\n  .pages-thumbnails {\n    overflow-x: auto;\n    padding: 10px;\n    gap: 10px;\n  }\n  \n  .page-thumbnail {\n    flex-shrink: 0;\n  }\n  \n  /* Current page container smaller on mobile */\n  .current-page-container {\n    padding: 10px;\n  }\n  \n  .page-editor {\n    max-width: 280px;\n  }\n}\n\n/* Small phone screens */\n@media (max-width: 600px) {\n  .library-photos {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 8px;\n  }\n  \n  .library-photo {\n    min-width: 40px;\n  }\n  \n  .page-editor {\n    max-width: 240px;\n  }\n  \n  .current-page-container {\n    min-height: 300px;\n    max-height: 45vh;\n  }\n  \n  .pages-thumbnails {\n    padding: 8px;\n    gap: 8px;\n  }\n  \n  .page-thumbnail {\n    width: 60px;\n  }\n\n  .spread-thumbnail {\n    width: 118px;\n  }\n}\n\n/* AI Generate Button */\n.ai-generate-btn {\n  padding: 10px 15px;\n  background: linear-gradient(135deg, #ff36f2 0%, #70eaeb 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.ai-generate-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.ai-generate-btn:active {\n  transform: translateY(0);\n}\n\n.ai-generate-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* AI Loading Overlay */\n.ai-loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.98);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  backdrop-filter: blur(8px);\n}\n\n.ai-loading-content {\n  text-align: center;\n  padding: 40px;\n}\n\n/* AI Star Spinner Animation */\n.ai-spinner {\n  position: relative;\n  width: 100px;\n  height: 100px;\n  margin: 0 auto 30px;\n}\n\n.ai-star {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ai-star svg {\n  width: 60px;\n  height: 60px;\n  animation: starPulse 2s ease-in-out infinite;\n}\n\n.ai-star svg path {\n  fill: #2d3748;\n}\n\n/* Sparkle particles */\n.sparkle {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  background: #2d3748;\n  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);\n  animation: sparkleFloat 2s ease-in-out infinite;\n}\n\n.sparkle:nth-child(1) {\n  top: 5px;\n  left: 50%;\n  animation-delay: 0s;\n}\n\n.sparkle:nth-child(2) {\n  top: 25%;\n  right: 5px;\n  animation-delay: 0.3s;\n}\n\n.sparkle:nth-child(3) {\n  bottom: 25%;\n  right: 10px;\n  animation-delay: 0.6s;\n}\n\n.sparkle:nth-child(4) {\n  bottom: 5px;\n  left: 50%;\n  animation-delay: 0.9s;\n}\n\n.sparkle:nth-child(5) {\n  top: 25%;\n  left: 5px;\n  animation-delay: 1.2s;\n}\n\n.sparkle:nth-child(6) {\n  bottom: 25%;\n  left: 10px;\n  animation-delay: 1.5s;\n}\n\n@keyframes starPulse {\n  0%, 100% {\n    transform: scale(1) rotate(0deg);\n    opacity: 1;\n  }\n  25% {\n    transform: scale(1.1) rotate(15deg);\n    opacity: 0.9;\n  }\n  50% {\n    transform: scale(0.95) rotate(-10deg);\n    opacity: 1;\n  }\n  75% {\n    transform: scale(1.05) rotate(5deg);\n    opacity: 0.95;\n  }\n}\n\n@keyframes sparkleFloat {\n  0%, 100% {\n    transform: scale(0.5) translateY(0);\n    opacity: 0.3;\n  }\n  50% {\n    transform: scale(1.2) translateY(-5px);\n    opacity: 1;\n  }\n}\n\n/* Orbiting dots */\n.orbit-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  animation: orbitSpin 4s linear infinite;\n}\n\n.orbit-dot {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  background: #4a5568;\n  border-radius: 50%;\n}\n\n.orbit-dot:nth-child(1) {\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.orbit-dot:nth-child(2) {\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.orbit-dot:nth-child(3) {\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n}\n\n.orbit-dot:nth-child(4) {\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n@keyframes orbitSpin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.ai-loading-text {\n  font-size: 24px;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0 0 10px 0;\n  letter-spacing: 0.5px;\n}\n\n.ai-loading-subtext {\n  font-size: 14px;\n  color: #718096;\n  margin: 0;\n}\n\n/* Large screens - wider photo library and bigger pages */\n@media (min-width: 1400px) {\n  .photo-library {\n    width: 320px;\n    min-width: 320px;\n    max-width: 320px;\n  }\n  \n  .library-photos {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 12px;\n  }\n  \n  .page-editor {\n    max-width: 400px;\n  }\n  \n  .current-page-container {\n    min-height: 550px;\n  }\n}\n\n/* Medium laptop screens */\n@media (min-width: 1100px) and (max-width: 1399px) {\n  .photo-library {\n    width: 280px;\n    min-width: 280px;\n    max-width: 280px;\n  }\n  \n  .library-photos {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n  }\n  \n  .page-editor {\n    max-width: 350px;\n  }\n}\n\n/* Small laptop screens. NOTE: .photo-library itself is NOT sized here -\n   at this width the mobile drawer is already active (see the ≤1100px\n   block above, matching PhotoBookDesigner.js's `isMobile` breakpoint), so\n   any fixed-column width set here would only fight with the drawer's\n   full-width treatment. Only .page-editor (the canvas page itself, still\n   rendered in-flow, not portalled) has a real width at this breakpoint. */\n@media (min-width: 901px) and (max-width: 1099px) {\n  .page-editor {\n    max-width: 300px;\n  }\n}\n\n/* ===== TEXT ELEMENTS ON PAGE ===== */\n.text-element {\n  position: absolute;\n  user-select: none;\n  touch-action: none;\n  border-radius: 3px;\n  min-width: 60px;\n  min-height: 24px;\n}\n\n.text-element-selected {\n  outline: 2px dashed #667eea;\n  outline-offset: 4px;\n  background: rgba(102, 126, 234, 0.06);\n  z-index: 30 !important;\n}\n\n/* Text formatting toolbar */\n.text-toolbar {\n  position: absolute;\n  top: -52px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1a202c;\n  border-radius: 8px;\n  padding: 6px 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n  z-index: 100;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.35);\n  flex-wrap: nowrap;\n  overflow: visible;\n}\n\n.text-font-select {\n  background: #2d3748;\n  color: #fff;\n  border: 1px solid #4a5568;\n  border-radius: 4px;\n  padding: 3px 5px;\n  font-size: 11px;\n  cursor: pointer;\n  max-width: 110px;\n}\n\n.text-font-select:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.text-size-input {\n  background: #2d3748;\n  color: #fff;\n  border: 1px solid #4a5568;\n  border-radius: 4px;\n  padding: 3px 4px;\n  font-size: 11px;\n  width: 42px;\n  text-align: center;\n}\n\n.text-size-input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.text-color-input {\n  width: 26px;\n  height: 26px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 0;\n  background: none;\n}\n\n.text-toolbar-divider {\n  width: 1px;\n  height: 20px;\n  background: #4a5568;\n  margin: 0 2px;\n  flex-shrink: 0;\n}\n\n.text-btn {\n  background: transparent;\n  color: #e2e8f0;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  padding: 3px 7px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n  line-height: 1;\n}\n\n.text-btn:hover {\n  background: #2d3748;\n  border-color: #4a5568;\n}\n\n.text-btn.active {\n  background: #667eea;\n  border-color: #667eea;\n  color: #fff;\n}\n\n.text-btn-delete {\n  color: #fc8181;\n}\n\n.text-btn-delete:hover {\n  background: #c53030;\n  border-color: #c53030;\n  color: #fff;\n}\n\n.text-btn-apply-all {\n  background: #38a169;\n  border-color: #38a169;\n  color: #fff;\n  font-size: 10px;\n  padding: 3px 8px;\n  white-space: nowrap;\n}\n\n.text-btn-apply-all:hover {\n  background: #2f855a;\n  border-color: #2f855a;\n}\n\n/* Text editing textarea */\n.text-edit-input {\n  width: 100%;\n  min-height: 40px;\n  background: rgba(255,255,255,0.9);\n  border: 1px solid #667eea;\n  border-radius: 3px;\n  resize: both;\n  padding: 4px;\n  outline: none;\n  box-sizing: border-box;\n}\n\n/* Mobile: text toolbar adjustments */\n@media (max-width: 768px) {\n  .text-toolbar {\n    top: -58px;\n    padding: 5px 6px;\n    gap: 3px;\n    max-width: 98vw;\n    overflow-x: auto;\n  }\n\n  .text-font-select {\n    max-width: 80px;\n    font-size: 10px;\n  }\n\n  .text-size-input {\n    width: 36px;\n    font-size: 10px;\n  }\n\n  .text-btn {\n    padding: 3px 5px;\n    font-size: 11px;\n  }\n\n  .text-btn-apply-all {\n    font-size: 9px;\n    padding: 3px 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
